module.exports = {"pi":{"clientId":"SDXgs4VjABgmXXA0iLjRyFeMqnYyVwHU"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/stg.config.json
// module id = 833
// module chunks = 0